<div fxLayout="column" [ngStyle]="{'max-height.px': innerHeight}" class="">

    <!-- Content scrollable -->
    <div class="p-4 scrolled text-sm text-center">
        <div [innerHTML]="saleMethod.description_order" class="decode-html-line"></div>
    </div>

    <!-- Close btn -->
    <div class="p-4 flex flex-col">

        <button class="w-full" [ngClass]="cssService.defaultNegativeDialogButton"  (click)="closeDial()" angulartics2On="click" angularticsAction="closeOrderInfoDial" angularticsCategory="order">
          <span>{{"dialogs.go-back" | translate}}</span>
        </button>

    </div>

</div>
